import React from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';

const GuidedTourControls = ({ currentStep, totalSteps, narration, onNext, onPrevious, onStop }) => {
  const progress = ((currentStep + 1) / totalSteps) * 100;

  return (
    <div className="absolute bottom-20 left-1/2 -translate-x-1/2 w-[95%] max-w-2xl">
      <div className="bg-card/95 backdrop-blur-sm border border-border rounded-lg shadow-2xl p-4 md:p-5">
        <div className="flex items-start justify-between mb-3">
          <div className="flex items-center gap-2">
            <div className="w-10 h-10 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
              <Icon name="Navigation" size={20} color="white" />
            </div>
            <div>
              <h3 className="text-sm font-semibold text-foreground">
                Guided Campus Tour
              </h3>
              <p className="text-xs text-muted-foreground">
                Step {currentStep + 1} of {totalSteps}
              </p>
            </div>
          </div>
          <Button
            variant="ghost"
            size="sm"
            iconName="X"
            onClick={onStop}
            aria-label="Stop guided tour"
          >
            <span className="hidden md:inline">Exit Tour</span>
          </Button>
        </div>

        <div className="mb-4">
          <div className="w-full h-2 bg-muted rounded-full overflow-hidden">
            <div
              className="h-full bg-primary transition-all duration-500"
              style={{ width: `${progress}%` }}
            />
          </div>
        </div>

        <div className="mb-4 p-3 bg-muted rounded-lg">
          <div className="flex items-start gap-2">
            <Icon name="Volume2" size={16} color="var(--color-primary)" className="mt-0.5 flex-shrink-0" />
            <p className="text-sm text-foreground leading-relaxed">
              {narration}
            </p>
          </div>
        </div>

        <div className="flex items-center justify-between gap-3">
          <Button
            variant="outline"
            size="sm"
            iconName="ChevronLeft"
            iconPosition="left"
            onClick={onPrevious}
            disabled={currentStep === 0}
          >
            Previous
          </Button>

          <div className="flex gap-1">
            {Array?.from({ length: totalSteps })?.map((_, index) => (
              <div
                key={index}
                className={`w-2 h-2 rounded-full transition-all ${
                  index === currentStep
                    ? 'bg-primary w-6'
                    : index < currentStep
                    ? 'bg-success' :'bg-muted-foreground/30'
                }`}
              />
            ))}
          </div>

          <Button
            variant="default"
            size="sm"
            iconName={currentStep === totalSteps - 1 ? 'Check' : 'ChevronRight'}
            iconPosition="right"
            onClick={onNext}
          >
            {currentStep === totalSteps - 1 ? 'Finish' : 'Next'}
          </Button>
        </div>
      </div>
    </div>
  );
};

export default GuidedTourControls;